"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EditProjectModal_1 = __importDefault(require("./EditProjectModal"));
exports.default = EditProjectModal_1.default;
